var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.618,
    height: 31.801,
    viewBox: "0 0 30.618 31.801",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bowl-chop-stick--cook-soup-bowl-chopsticks-cooking-nutrition-asian-food-kitchenware",
    transform: "translate(-2.679 -0.674)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.714,12.518l7.2-10.8",
    transform: "translate(-6.68 0)",
    fill: "none",
    stroke: "#ed3237",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M32.571,15.774l8.4-7.2",
    transform: "translate(-8.735 -2.055)",
    fill: "none",
    stroke: "#ed3237",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_1888",
    "data-name": "Ellipse 1888",
    d: "M17.834,38.405A14.405,14.405,0,0,0,32.239,24H3.429A14.405,14.405,0,0,0,17.834,38.405Z",
    transform: "translate(0 -6.68)",
    fill: "none",
    stroke: "#314286",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeal);
export default __webpack_public_path__ + "static/media/meal.cfb7d293993a25c43843033d38e9e53d.svg";
export { ForwardRef as ReactComponent };